import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles({
	button: {
		padding: 3,
		fontSize: "12px",
		minWidth: "40px",
		...ColorUtil.getBackgroundAndContrastColor(colors.getPrimaryColor()),
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.getPrimaryColor())
		},
		"& svg": {
			fontSize: "16px !important"
		}
	},
	saveButton: {
		border: "1px solid",
		boxShadow: "none",
		borderColor: "rgba(126, 13, 214, 0.12)",
		fontWeight: 500,
		...ColorUtil.getBackgroundAndContrastColor("transparent"),
		color: colors.getPrimaryColor(),
		letterSpacing: 0.4,
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor("transparent"),
			boxShadow: "none"
		},
		fontSize: "14px",
		padding: "8px 16px"
	}
})

export default useStyles
